/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
==========================================================================================*/

import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

import VueMoment from 'vue-moment'
import moment from 'moment'

require('moment/locale/fr')

Vue.use(VueMoment, {
    moment
})

// axios
import axios from './axios.js'
import VueAxios from 'vue-axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.withCredentials = false
Vue.use(VueAxios, axios)

// ACL
import acl from './acl/acl'

// Filters
import './filters/filters.js'

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// i18n
import i18n from './i18n/i18n'

// VeeValidate
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate, {
    events: 'change|input|keyup'
})

// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer'
import {mapGetters} from "vuex";

Vue.use(VueHammer)

// Feather font icon
require('./assets/css/iconfont.css')

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false

const app = new Vue({
    router,
    store,
    i18n,
    acl,
    computed: {
        ...mapGetters('user', ['activeUser']),
    },
    created() {
        Vue.axios.interceptors.response.use(
            response => response,
            error => {
                if ((error.response.status === 401 || error.response.status === 499) && this.$route.path !== '/pages/login') {
                    this.$store.dispatch('user/logout')
                }
                return Promise.reject(error)
            }
        )
        this.$store.dispatch('user/restoreState');

        if(this.activeUser){
            if (JSON.parse(this.activeUser.roles).includes('ROLE_LOGIN')) {
                this.$acl.change('login');
                this.$router.push({path: '/account-verification'})
            } else {
                if ((JSON.parse(this.activeUser.roles).includes('ROLE_ADMIN') || JSON.parse(this.activeUser.roles).includes('ROLE_ECHEANCEUR') || JSON.parse(this.activeUser.roles).includes('ROLE_MANAGER'))) {
                    this.$acl.change('admin')
                } else if (JSON.parse(this.activeUser.roles).includes('ROLE_USER')) {
                    this.$acl.change('subscriber')
                }
            }
        }else{
            this.$acl.change('subscriber')
        }
    },
    render: h => h(App)
}).$mount('#app')

store.$app = app
